import { Switch, SwitchProps } from "@chakra-ui/react";
import { ForwardedRef, forwardRef } from "react";

type Props = Omit<SwitchProps, "isChecked" | "onChange" | "value"> & {
  onChange?: (value: boolean) => void;
  value?: boolean | null;
};

function SwitchInput(
  { onChange, value, ...rest }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <Switch
      ref={ref}
      isChecked={!!value}
      onChange={(evt) => onChange?.(evt.target.checked)}
      size="lg"
      {...rest}
    />
  );
}

export default forwardRef(SwitchInput);
